import { Box, Switch, Typography } from '@material-ui/core';
import { CompareArrows } from '@material-ui/icons';
import React from 'react';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { GET_MATCHING_CONFIG_ITEM } from './admin-console-matching.gql';
import { GetMatchingConfigItem } from './__generated__/GetMatchingConfigItem';

interface Props {
  onChange?: (enabled: boolean) => void;
}

export function AllowVolunteerMatching({ onChange }: Props) {
  const [queryConfigItem] = useCampfireLazyQuery<GetMatchingConfigItem, { key: string }>(GET_MATCHING_CONFIG_ITEM);
  const [enabled, setEnabled] = React.useState(false);
  const { setSnackbar } = useSnackbar();
  const apiUrl = useApiUrl();
  const saveConfigItem = useCampfireFetch({ defer: true });

  React.useEffect(() => {
    queryConfigItem({ variables: { key: 'allow-volunteer-matching' } }).then((response) => {
      const value =
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false;
      setEnabled(value);
      if (onChange) onChange(value);
    });
  }, []);

  const onMatchingChange = () => {
    const next = !enabled;
    saveConfigItem
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'allow-volunteer-matching',
          value: next,
        },
      })
      .then(() => {
        setSnackbar({
          variant: 'success',
          open: true,
          message: 'Settings updated',
        });
      });
    setEnabled(next);
    if (onChange) onChange(next);
  };

  return (
    <Box>
      <>
        <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
          <CompareArrows style={{ fontSize: '14px', paddingRight: '5px' }} /> Volunteer Matching
        </Typography>
        <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080' }}>
          {'Settings related to pairing incoming volunteers with one another'}
        </Typography>
        <Box display='flex' flex='1 1 auto' marginTop='1.5em'>
          <Box style={{ paddingTop: 4, paddingRight: 8 }}>
            <Switch
              name='volunteer-matching-toggle'
              color='primary'
              checked={enabled}
              onChange={() => onMatchingChange()}
              inputProps={{ 'aria-label': 'volunteer matching checkbox' }}
            />
          </Box>
          <Box>
            <Box ml={1}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#333',
                }}
              >
                Suggest Matches
              </Typography>
              <Typography style={{ fontSize: '13px', color: '#808080' }}>
                Coordinators see a panel of suggested counterparts when reviewing an incoming volunteer. <br />
                You can define which roles get paired via the rules below. Suggestions are never applied automatically.
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    </Box>
  );
}
